/* eslint-disable no-unused-vars */
import pick from 'lodash/pick';
import isEmpty from 'lodash/isEmpty';
import { get } from 'lodash';
import moment from 'moment';
import config from '../config';
import { storableError } from '../util/errors';
import {
  txIsEnquired,
  TRANSITION_ACCEPT,
  TRANSITION_DECLINE,
  TRANSITION_CUSTOMER_CANCEL_WITH_REFUND,
  TRANSITION_CUSTOMER_CANCEL_WITHOUT_REFUND,
  TRANSITION_CUSTOMER_LATE_CANCEL,
  TRANSITION_PROVIDER_EARLY_CANCEL,
  TRANSITION_PROVIDER_CANCEL,
  TRANSITION_PROVIDER_LATE_CANCEL,
  TRANSITION_PROVIDER_SPECIAL_OFFER,
  TRANSITION_CUSTOMER_ACCEPT_OFFER,
  TRANSITION_CUSTOMER_DECLINE_OFFER,
  TRANSITION_SPECIAL_CUSTOMER_PAYMENT,
  TRANSITION_PROVIDER_CANCEL_OFFER,
  TRANSITION_CONFIRM_PAYMENT,
  TRANSITION_REFUND_PERIOD_OVER,
  TRANSITION_PARTY_MEMBERS_SUBMITTED_1,
  TRANSITION_PARTY_MEMBERS_SUBMITTED_2,
  TRANSITION_PARTY_MEMBERS_SUBMITTED_3,
  TRANSITION_REQUESTED_CHANGES,
  TRANSITION_ACCEPTED_CHANGES,
  TRANSITION_DECLINED_CHANGES,
  isLegacyPaymentFlow,
  txIsAccepted,
  hasPaymentIntent,
  hasProviderAcceptedChanges,
  txIsCustomerCancellableNonRefundable,
  TRANSITION_REQUESTED_CHANGES_AFTER_REFUND_PERIOD,
  TRANSITION_ACCEPTED_CHANGES_AFTER_REFUND_PERIOD,
  TRANSITION_DECLINED_CHANGES_AFTER_REFUND_PERIOD,
  txIsEnquiryExpired,
  TRANSITION_PROVIDER_SPECIAL_OFFER_AFTER_EXPIRED_ENQUIRY,
  TRANSITION_CHANGES_REQUEST_EXPIRE_AFTER_REFUND,
  getTransactionMessages,
  storeTransactionMessage,
  removeTransactionMessage,
  buildEmailsMeta,
} from '../util/transaction';
import * as log from '../util/log';
import analytics from '../util/affiliate';
import { updatedEntities, denormalisedEntities, denormalisedResponseEntities } from '../util/data';
import { daysAdded, daysBetween } from '../util/dates';
import { getListingTimezone, getPackage, listingStateLinks } from '../util/listing';
import {
  addMarketplaceEntities,
  getListingById,
  getMarketplaceEntities,
  getTransactionById,
} from './marketplaceData.duck';
import {
  fetchCurrentUserHasOrdersSuccess,
  fetchCurrentUserNotifications,
  fetchCurrentUser,
} from './user.duck';
import {
  compareLineItemTotals,
  stripeCancel,
  stripeCapture,
  stripeCreate,
  stripePayout,
  stripeRefund,
  stripeRetrieve,
  callGraphQLApi,
  updateTransactionMetadata as updateTransactionMetadataApi,
  sendMessageApi,
} from '../util/api';
import { updateListing } from './listing.duck';
import { FETCH_ORDER_OR_SALE_SUCCESS } from '../containers/InboxPageV2/InboxPageV2.duck';
import queryClient from '../util/queryClient';
import { MESSAGES_QUERY_KEY } from '../hooks/queries/useMessages';
import { TRANSACTIONS_QUERY_KEY } from '../hooks/queries/useTransactions';
import { trackPurchaseEventDirectly } from '../tracking/helpers';
import { convertMoneyToNumber } from '../util/currency';
const {
  LINE_ITEM_ADULT_HUNTER,
  LINE_ITEM_ADULT_NON_HUNTER,
  LINE_ITEM_YOUTH_HUNTER,
  LINE_ITEM_YOUTH_NON_HUNTER,
  PAYMENT_INTENT_TYPES,
} = require('../shared/transaction');

const IMAGE_VARIANTS = {
  'fields.image': [
    // Profile images
    'variants.square-small',
    'variants.square-small2x',

    // Listing images:
    'variants.landscape-crop',
    'variants.landscape-crop2x',
    'variants.landscape-crop4x',
    'variants.scaled-small',
    'variants.scaled-medium',
    'variants.scaled-large',
    'variants.scaled-xlarge',
    'variants.square-small',
    'variants.square-small2x',
    'variants.facebook',
    'variants.twitter',
  ],
};

// ================ Action types ================ //

export const SET_INITAL_VALUES = 'app/transaction/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/transaction/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/transaction/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/transaction/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSACTIONS_TOGETHER_REQUEST =
  'app/transaction/FETCH_TRANSACTIONS_TOGETHER_REQUEST';
export const FETCH_TRANSACTIONS_TOGETHER_SUCCESS =
  'app/transaction/FETCH_TRANSACTIONS_TOGETHER_SUCCESS';
export const FETCH_TRANSACTIONS_TOGETHER_ERROR =
  'app/transaction/FETCH_TRANSACTIONS_TOGETHER_ERROR';

export const INITIATE_OFFER_REQUEST = 'app/transaction/INITIATE_OFFER_REQUEST';
export const INITIATE_OFFER_SUCCESS = 'app/transaction/INITIATE_OFFER_SUCCESS';
export const INITIATE_OFFER_ERROR = 'app/transaction/INITIATE_OFFER_ERROR';

export const FETCH_TRANSITIONS_REQUEST = 'app/transaction/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS = 'app/transaction/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR = 'app/transaction/FETCH_TRANSITIONS_ERROR';

export const ACCEPT_SALE_REQUEST = 'app/transaction/ACCEPT_SALE_REQUEST';
export const ACCEPT_SALE_SUCCESS = 'app/transaction/ACCEPT_SALE_SUCCESS';
export const ACCEPT_SALE_ERROR = 'app/transaction/ACCEPT_SALE_ERROR';

export const CANCEL_SALE_REQUEST = 'app/transaction/CANCEL_SALE_REQUEST';
export const CANCEL_SALE_SUCCESS = 'app/transaction/CANCEL_SALE_SUCCESS';
export const CANCEL_SALE_ERROR = 'app/transaction/CANCEL_SALE_ERROR';

export const DECLINE_SALE_REQUEST = 'app/transaction/DECLINE_SALE_REQUEST';
export const DECLINE_SALE_SUCCESS = 'app/transaction/DECLINE_SALE_SUCCESS';
export const DECLINE_SALE_ERROR = 'app/transaction/DECLINE_SALE_ERROR';

export const FETCH_MESSAGES_REQUEST = 'app/transaction/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'app/transaction/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/transaction/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/transaction/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/transaction/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/transaction/SEND_MESSAGE_ERROR';

export const UPDATE_PARTY_MEMBER_DETAILS_REQUEST =
  'app/transaction/UPDATE_PARTY_MEMBER_DETAILS_REQUEST';
export const UPDATE_PARTY_MEMBER_DETAILS_SUCCESS =
  'app/transaction/UPDATE_PARTY_MEMBER_DETAILS_SUCCESS';
export const UPDATE_PARTY_MEMBER_DETAILS_ERROR =
  'app/transaction/UPDATE_PARTY_MEMBER_DETAILS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/transaction/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/transaction/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/transaction/FETCH_TIME_SLOTS_ERROR';

export const CONFIRM_OFFER_PAYMENT_REQUEST = 'app/transaction/CONFIRM_OFFER_PAYMENT_REQUEST';
export const CONFIRM_OFFER_PAYMENT_SUCCESS = 'app/transaction/CONFIRM_OFFER_PAYMENT_SUCCESS';
export const CONFIRM_OFFER_PAYMENT_ERROR = 'app/transaction/CONFIRM_OFFER_PAYMENT_ERROR';

export const DECLINE_OFFER_SUCCESS = 'app/transaction/DECLINE_OFFER_SUCCESS';
export const CANCEL_OFFER_SUCCESS = 'app/transaction/CANCEL_OFFER_SUCCESS';

export const REQUESTED_CHANGES_REQUEST = 'app/transaction/REQUESTED_CHANGES_REQUEST';
export const REQUESTED_CHANGES_SUCCESS = 'app/transaction/REQUESTED_CHANGES_SUCCESS';
export const REQUESTED_CHANGES_ERROR = 'app/transaction/REQUESTED_CHANGES_ERROR';

export const ACCEPT_CHANGES_REQUEST = 'app/transaction/ACCEPT_CHANGES_REQUEST';
export const ACCEPT_CHANGES_SUCCESS = 'app/transaction/ACCEPT_CHANGES_SUCCESS';
export const ACCEPT_CHANGES_ERROR = 'app/transaction/ACCEPT_CHANGES_ERROR';

export const DECLINE_CHANGES_REQUEST = 'app/transaction/DECLINE_CHANGES_REQUEST';
export const DECLINE_CHANGES_SUCCESS = 'app/transaction/DECLINE_CHANGES_SUCCESS';
export const DECLINE_CHANGES_ERROR = 'app/transaction/DECLINE_CHANGES_ERROR';

export const FETCH_REVIEW_DATA_REQUEST = 'app/transaction/FETCH_REVIEW_DATA_REQUEST';
export const FETCH_REVIEW_DATA_SUCCESS = 'app/transaction/FETCH_REVIEW_DATA_SUCCESS';

export const MARK_MESSAGES_READ_REQUEST = 'app/transaction/MARK_MESSAGES_READ_REQUEST';
export const MARK_MESSAGES_READ_SUCCESS = 'app/transaction/MARK_MESSAGES_READ_SUCCESS';
export const MARK_MESSAGES_READ_ERROR = 'app/transaction/MARK_MESSAGES_READ_ERROR';

export const UPDATE_TRANSACTION_METADATA_REQUEST =
  'app/transaction/UPDATE_TRANSACTION_METADATA_REQUEST';
export const UPDATE_TRANSACTION_METADATA_SUCCESS =
  'app/transaction/UPDATE_TRANSACTION_METADATA_SUCCESS';
export const UPDATE_TRANSACTION_METADATA_ERROR =
  'app/transaction/UPDATE_TRANSACTION_METADATA_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  acceptInProgress: false,
  acceptSaleError: null,
  cancelInProgress: false,
  cancelSaleError: null,
  declineInProgress: false,
  declineSaleError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  confirmOfferPaymentError: null,
  fetchTransactionsTogetherError: null,
  fetchTransactionsTogetherTransactions: null,
  currentUsersHaveOrdersTogether: false,
  requestedChangesInProgress: false,
  requestedChangesError: null,
  acceptChangesInProgress: false,
  acceptChangesError: null,
  declineChangesInProgress: false,
  declineChangesError: null,
  review: null,
  fetchingReviewDataInProgress: false,
  markMessagesReadInProgress: false,
  markMessagesReadError: null,
  updateMetadataInProgress: false,
  updateMetadataError: null,
};

export default function checkoutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchTransactionInProgress: true,
        fetchTransactionError: null,
        transactionRole: payload.transactionRole,
      };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case FETCH_TRANSACTIONS_TOGETHER_REQUEST:
      return { ...state, fetchTransactionsTogetherError: null };
    case FETCH_TRANSACTIONS_TOGETHER_SUCCESS:
      return {
        ...state,
        fetchTransactionsTogetherTransactions: payload,
        currentUsersHaveOrdersTogether: payload.hasOrdersTogether || false,
      };
    case FETCH_TRANSACTIONS_TOGETHER_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionsTogetherError: payload };

    case FETCH_TRANSITIONS_REQUEST:
      return { ...state, fetchTransitionsInProgress: true, fetchTransitionsError: null };
    case FETCH_TRANSITIONS_SUCCESS:
      return { ...state, fetchTransitionsInProgress: false, processTransitions: payload };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransitionsInProgress: false, fetchTransitionsError: payload };

    case INITIATE_OFFER_REQUEST:
      return { ...state, initiateOfferError: null };
    case INITIATE_OFFER_SUCCESS:
      return { ...state, transaction: payload.transaction };
    case INITIATE_OFFER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, initiateOfferError: payload };

    case ACCEPT_SALE_REQUEST:
      return { ...state, acceptInProgress: true, acceptSaleError: null, declineSaleError: null };
    case ACCEPT_SALE_SUCCESS:
      return { ...state, acceptInProgress: false };
    case ACCEPT_SALE_ERROR:
      return { ...state, acceptInProgress: false, acceptSaleError: payload };

    case CANCEL_SALE_REQUEST:
      return { ...state, cancelInProgress: true, cancelSaleError: null, declineSaleError: null };
    case CANCEL_SALE_SUCCESS:
      return { ...state, cancelInProgress: false };
    case CANCEL_SALE_ERROR:
      return { ...state, cancelInProgress: false, cancelSaleError: payload };

    case DECLINE_SALE_REQUEST:
      return { ...state, declineInProgress: true, declineSaleError: null, acceptSaleError: null };
    case DECLINE_SALE_SUCCESS:
      return { ...state, declineInProgress: false };
    case DECLINE_SALE_ERROR:
      return { ...state, declineInProgress: false, declineSaleError: payload };

    case FETCH_MESSAGES_REQUEST:
      return { ...state, fetchMessagesInProgress: true, fetchMessagesError: null };
    case FETCH_MESSAGES_SUCCESS: {
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: payload.messages,
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchMessagesInProgress: false, fetchMessagesError: payload };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return { ...state, sendMessageInProgress: false, sendMessageError: payload };

    case UPDATE_PARTY_MEMBER_DETAILS_REQUEST:
      return { ...state, updatePartyMemberFormInProgress: true, updatePartyMemberFormError: null };
    case UPDATE_PARTY_MEMBER_DETAILS_SUCCESS:
      return { ...state, updatePartyMemberFormInProgress: false };
    case UPDATE_PARTY_MEMBER_DETAILS_ERROR:
      return {
        ...state,
        updatePartyMemberFormInProgress: false,
        updatePartyMemberFormError: payload,
      };

    case FETCH_TIME_SLOTS_REQUEST:
      return { ...state, fetchTimeSlotsError: null };
    case FETCH_TIME_SLOTS_SUCCESS:
      return { ...state, timeSlots: payload };
    case FETCH_TIME_SLOTS_ERROR:
      return { ...state, fetchTimeSlotsError: payload };

    case CONFIRM_OFFER_PAYMENT_REQUEST:
      return { ...state, confirmOfferPaymentError: null };
    case CONFIRM_OFFER_PAYMENT_SUCCESS:
      return state;
    case CONFIRM_OFFER_PAYMENT_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, confirmOfferPaymentError: payload };

    case REQUESTED_CHANGES_REQUEST:
      return {
        ...state,
        requestedChangesInProgress: true,
        requestedChangesError: null,
      };
    case REQUESTED_CHANGES_SUCCESS:
      return { ...state, requestedChangesInProgress: false };
    case REQUESTED_CHANGES_ERROR:
      return {
        ...state,
        requestedChangesInProgress: false,
        requestedChangesError: payload,
      };

    case ACCEPT_CHANGES_REQUEST:
      return {
        ...state,
        acceptChangesInProgress: true,
        acceptChangesError: null,
      };
    case ACCEPT_CHANGES_SUCCESS:
      return { ...state, acceptChangesInProgress: false };
    case ACCEPT_CHANGES_ERROR:
      return {
        ...state,
        acceptChangesInProgress: false,
        acceptChangesError: payload,
      };

    case DECLINE_CHANGES_REQUEST:
      return {
        ...state,
        declineChangesInProgress: true,
        declineChangesError: null,
      };
    case DECLINE_CHANGES_SUCCESS:
      return { ...state, declineChangesInProgress: false };
    case DECLINE_CHANGES_ERROR:
      return {
        ...state,
        declineChangesInProgress: false,
        declineChangesError: payload,
      };
    case FETCH_REVIEW_DATA_REQUEST:
      return {
        ...state,
        fetchingReviewDataInProgress: true,
      };
    case FETCH_REVIEW_DATA_SUCCESS: {
      return {
        ...state,
        review: payload.review,
        fetchingReviewDataInProgress: false,
      };
    }

    case MARK_MESSAGES_READ_REQUEST:
      return {
        ...state,
        markMessagesReadInProgress: true,
        markMessagesReadError: null,
      };
    case MARK_MESSAGES_READ_SUCCESS:
      return {
        ...state,
        markMessagesReadInProgress: false,
      };
    case MARK_MESSAGES_READ_ERROR:
      return {
        ...state,
        markMessagesReadInProgress: false,
        markMessagesReadError: payload,
      };

    case UPDATE_TRANSACTION_METADATA_REQUEST:
      return {
        ...state,
        updateMetadataInProgress: true,
        updateMetadataError: null,
      };
    case UPDATE_TRANSACTION_METADATA_SUCCESS:
      return {
        ...state,
        updateMetadataInProgress: false,
      };
    case UPDATE_TRANSACTION_METADATA_ERROR:
      return {
        ...state,
        updateMetadataInProgress: false,
        updateMetadataError: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const acceptOrDeclineInProgress = state => {
  return state.Transaction.acceptInProgress || state.Transaction.declineInProgress;
};
export const cancelInProgress = state => {
  return state.Transaction.cancelInProgress;
};
export const requestChangesInProgress = state => {
  return state.TransactionPage.requestedChangesInProgress;
};

export const acceptChangesInProgress = state => {
  return state.TransactionPage.acceptChangesInProgress;
};

export const declineChangesInProgress = state => {
  return state.TransactionPage.declineChangesInProgress;
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = txRole => ({
  type: FETCH_TRANSACTION_REQUEST,
  payload: { transactionRole: txRole },
});
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchOrderOrSaleSuccess = response => ({
  type: FETCH_ORDER_OR_SALE_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

const fetchTransactionsTogetherRequest = () => ({
  type: FETCH_TRANSACTIONS_TOGETHER_REQUEST,
});

export const fetchTransactionsTogetherSuccess = (transactions, hasOrdersTogether) => ({
  type: FETCH_TRANSACTIONS_TOGETHER_SUCCESS,
  payload: { transactions, hasOrdersTogether },
});

const fetchTransactionsTogetherError = e => ({
  type: FETCH_TRANSACTIONS_TOGETHER_ERROR,
  error: true,
  payload: e,
});

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({ type: FETCH_TRANSITIONS_ERROR, error: true, payload: e });

const initiateOfferRequest = () => ({ type: INITIATE_OFFER_REQUEST });
const initiateOfferSuccess = payload => ({
  type: INITIATE_OFFER_SUCCESS,
  payload,
});
const initiateOfferError = e => ({
  type: INITIATE_OFFER_ERROR,
  error: true,
  payload: e,
});

const acceptSaleRequest = () => ({ type: ACCEPT_SALE_REQUEST });
const acceptSaleSuccess = id => ({ type: ACCEPT_SALE_SUCCESS, payload: { id } });
const acceptSaleError = e => ({ type: ACCEPT_SALE_ERROR, error: true, payload: e });

const cancelSaleRequest = () => ({ type: CANCEL_SALE_REQUEST });
const cancelSaleSuccess = id => ({ type: CANCEL_SALE_SUCCESS, payload: { id } });
const cancelSaleError = e => ({ type: CANCEL_SALE_ERROR, error: true, payload: e });

const declineSaleRequest = () => ({ type: DECLINE_SALE_REQUEST });
const declineSaleSuccess = id => ({ type: DECLINE_SALE_SUCCESS, payload: { id } });
const declineSaleError = e => ({ type: DECLINE_SALE_ERROR, error: true, payload: e });

const declineOfferSuccess = id => ({ type: DECLINE_OFFER_SUCCESS, payload: { id } });
const cancelOfferSuccess = id => ({ type: CANCEL_OFFER_SUCCESS, payload: { id } });

const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (txId, messages, pagination) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { txId, messages, ...pagination },
});
const fetchMessagesError = e => ({ type: FETCH_MESSAGES_ERROR, error: true, payload: e });

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = txId => ({ type: SEND_MESSAGE_SUCCESS, payload: { txId } });
const sendMessageError = e => ({ type: SEND_MESSAGE_ERROR, error: true, payload: e });

export const updatePartyMemberDetailsRequest = () => ({
  type: UPDATE_PARTY_MEMBER_DETAILS_REQUEST,
});

export const updatePartyMemberDetailsSuccess = id => ({
  type: UPDATE_PARTY_MEMBER_DETAILS_SUCCESS,
  payload: { id },
});

export const updatePartyMemberDetailsError = () => ({
  type: UPDATE_PARTY_MEMBER_DETAILS_ERROR,
});

const fetchTimeSlotsRequest = () => ({ type: FETCH_TIME_SLOTS_REQUEST });
const fetchTimeSlotsSuccess = timeSlots => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: timeSlots,
});
const fetchTimeSlotsError = e => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: e,
});

const confirmOfferPaymentRequest = () => ({ type: CONFIRM_OFFER_PAYMENT_REQUEST });

const confirmOfferPaymentSuccess = id => ({
  type: CONFIRM_OFFER_PAYMENT_SUCCESS,
  payload: { id },
});

const confirmOfferPaymentError = e => ({
  type: CONFIRM_OFFER_PAYMENT_ERROR,
  error: true,
  payload: e,
});

const requestChangesRequest = () => ({ type: REQUESTED_CHANGES_REQUEST });
const requestChangesSuccess = id => ({
  type: REQUESTED_CHANGES_SUCCESS,
  payload: { id },
});
const requestChangesError = e => ({
  type: REQUESTED_CHANGES_ERROR,
  error: true,
  payload: e,
});

const acceptChangesRequest = () => ({ type: ACCEPT_CHANGES_REQUEST });
const acceptChangesSuccess = id => ({
  type: ACCEPT_CHANGES_SUCCESS,
  payload: { id },
});
const acceptChangesError = e => ({
  type: ACCEPT_CHANGES_ERROR,
  error: true,
  payload: e,
});

const declineChangesRequest = () => ({ type: DECLINE_CHANGES_REQUEST });
const declineChangesSuccess = id => ({
  type: DECLINE_CHANGES_SUCCESS,
  payload: { id },
});
const declineChangesError = e => ({
  type: DECLINE_CHANGES_ERROR,
  error: true,
  payload: e,
});
export const fetchReviewDataRequest = () => ({
  type: FETCH_REVIEW_DATA_REQUEST,
});

export const fetchReviewDataSuccess = review => ({
  type: FETCH_REVIEW_DATA_SUCCESS,
  payload: review,
});

const markMessagesReadRequest = () => ({ type: MARK_MESSAGES_READ_REQUEST });
const markMessagesReadSuccess = response => ({
  type: MARK_MESSAGES_READ_SUCCESS,
  payload: response,
});
const markMessagesReadError = error => ({
  type: MARK_MESSAGES_READ_ERROR,
  error: true,
  payload: error,
});

const updateTransactionMetadataRequest = () => ({ type: UPDATE_TRANSACTION_METADATA_REQUEST });
const updateTransactionMetadataSuccess = response => ({
  type: UPDATE_TRANSACTION_METADATA_SUCCESS,
  payload: response,
});
const updateTransactionMetadataError = error => ({
  type: UPDATE_TRANSACTION_METADATA_ERROR,
  error: true,
  payload: error,
});

// ================ Thunks ================ //

export const updateTransactionTransition = (
  transactionId,
  createdAt,
  lastTransition,
  lastTransitionedAt
) => async () => {
  const mutation = `
    mutation UpdateTransactionTransition($input: UpdateTransactionTransitionInput!) {
      UpdateTransactionTransition(input: $input) 
    }
  `;

  const variables = {
    input: {
      transactionId,
      createdAt,
      lastTransition,
      lastTransitionedAt,
    },
  };

  try {
    const response = await callGraphQLApi(mutation, variables);

    queryClient.invalidateQueries({ queryKey: [TRANSACTIONS_QUERY_KEY] });

    return response.data.UpdateTransactionTransition;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
};

export const fetchReview = (txId, userId) => async (dispatch, getState, sdk) => {
  dispatch(fetchReviewDataRequest());
  try {
    const response = await callGraphQLApi(
      `
        query GetReview($transactionId: ID!, $authorId: ID!) {
          GetReview(input: { transactionId: $transactionId, authorId: $authorId }) {
            item {
              authorId
              authorRole
              createdAt
              id
              listingId
              packageId
              photos
              rating
              reviewContent
              status
              transactionId
            }
          }
        }`,
      {
        authorId: userId.uuid,
        transactionId: txId.uuid,
      }
    );

    const review = response?.data?.GetReview?.item;

    // Dispatching action to handle successful data retrieval
    dispatch(
      fetchReviewDataSuccess({
        review,
      })
    );
    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
};

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

export const sendMessage = params => (dispatch, getState, sdk) => {
  const { txId, message, customerId, providerId, senderType } = params;
  const senderId = senderType === 'customer' ? customerId : providerId;
  dispatch(sendMessageRequest());

  return sendMessageApi({ transactionId: txId, content: message, userId: senderId })
    .then(response => {
      const createdAt = response?.data?.data?.attributes?.createdAt;
      const createdAtString =
        createdAt instanceof Date ? createdAt.getTime() : new Date(createdAt).getTime();
      const messageId = response?.data?.data?.id?.uuid;

      const newMessage = {
        messageId,
        content: message,
        createdAt: `${createdAtString}`,
        customerId,
        messageSource: 'sharetribe',
        providerId,
        senderId: senderType === 'customer' ? customerId : providerId,
        transactionId: txId.uuid,
      };

      storeTransactionMessage(txId.uuid, newMessage);

      dispatch(sendMessageSuccess(txId));

      queryClient.invalidateQueries({ queryKey: [MESSAGES_QUERY_KEY, txId.uuid] });

      return newMessage;
    })
    .catch(e => {
      dispatch(sendMessageError(storableError(e)));
      throw e;
    });
};

export const specialOfferOrder = (orderParams, transactionId, tx) => (dispatch, getState, sdk) => {
  const { bookingDates, bookingData, listing } = orderParams;
  const { bookingStart, bookingEnd } = bookingDates;
  const { anchorTag, listingState, stateStatute } = listingStateLinks(listing);

  let nextTransition = null;

  if (txIsEnquired(tx)) {
    nextTransition = TRANSITION_PROVIDER_SPECIAL_OFFER;
  }

  if (txIsEnquiryExpired(tx)) {
    nextTransition = TRANSITION_PROVIDER_SPECIAL_OFFER_AFTER_EXPIRED_ENQUIRY;
  }

  const protectedData = {
    offerMessage: bookingData.offerMessage,
    stateStatute: stateStatute && stateStatute,
    listingState: stateStatute &&
      listingState &&
      anchorTag && { anchor: anchorTag, state: listingState },
    bookingDates: {},
    utm: { ...analytics.all() },
  };

  // We wanna get the date at the listing location.
  // This will then be used for the display dates which are hooked
  // with our process.end transitions
  const timezone = getListingTimezone(listing);

  const bookingStartDate = moment(bookingStart).format('YYYY-MM-DD');
  const bookingEndDate = moment(bookingEnd).format('YYYY-MM-DD');

  const bookingStartDateInLocale = moment.tz(`${bookingStartDate} 00:00:00`, timezone);
  const bookingEndDateInLocale = moment.tz(`${bookingEndDate} 23:59:59`, timezone);

  const bookingStartDateInLocaleInUTC = moment(bookingStartDateInLocale).utc();
  const bookingEndDateInLocaleInUTC = moment(bookingEndDateInLocale).utc();

  const bookingDisplayStart = bookingStartDateInLocaleInUTC.toDate();
  const bookingDisplayEnd = bookingEndDateInLocaleInUTC.toDate();

  // We will store the booking dates and timezone into protected data
  // in order to access it later when displaying the dates to the guests
  // (using the listing time, NOT local guest time!!!).
  protectedData.bookingDates = {
    start: bookingStartDateInLocale.format(),
    end: bookingEndDateInLocale.format(),
    timezone,
    days: daysBetween(bookingStartDateInLocale.format(), bookingEndDateInLocale.format()) + 1,
  };
  // Trip Details in the booking confirmation emails read protectedData.emailsMeta.
  const txProtectedData = get(tx, 'attributes.protectedData', {}) || {};
  const selectedPackage = txProtectedData.selectedPackage || {};
  const listingPackage = getPackage(listing, selectedPackage.packageId) || {};
  protectedData.emailsMeta = buildEmailsMeta({
    listing,
    packageItem: {
      activity: selectedPackage.packageActivity || listingPackage.activity || null,
      hasLodging: listingPackage.hasLodging || false,
    },
    bookingStart,
    bookingEnd,
    bookingGuestSize: get(txProtectedData, 'partySize.partySize', null),
  });

  // The API booking end date is always exclusive. In order to have e.g.
  // 1st of Jul - 2nd of July we need to send end date as 3rd.
  // Important, the 3rd of July won't be blocked from future bookings.
  const apiBookingEnd = moment
    .utc(bookingEnd)
    .set({ hour: 0, minute: 0, seconds: 0 })
    .add(1, 'd')
    .toDate();
  const apiBookingStart = moment
    .utc(bookingStart)
    .set({ hour: 0, minute: 0 })
    .toDate();

  dispatch(initiateOfferRequest());
  const bodyParams = {
    id: transactionId,
    transition: nextTransition,
    params: {
      bookingStart: apiBookingStart,
      bookingEnd: apiBookingEnd,
      bookingDisplayStart,
      bookingDisplayEnd,
      negotiatedTotal: bookingData.specialOffer,
      protectedData,
    },
  };
  const queryParams = {
    include: ['booking', 'provider', 'listing', 'author', 'customer'],
    expand: true,
  };
  return sdk.transactions
    .transition(bodyParams, queryParams)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      const transaction = entities[0];

      dispatch(addMarketplaceEntities(response));
      dispatch(initiateOfferSuccess({ transaction }));
      dispatch(fetchCurrentUserHasOrdersSuccess(true));

      dispatch(
        updateTransactionTransition(
          transaction.id.uuid,
          transaction.attributes.createdAt.toISOString(),
          transaction.attributes.lastTransition,
          transaction.attributes.lastTransitionedAt.toISOString()
        )
      );

      return transaction;
    })
    .catch(e => {
      dispatch(initiateOfferError(storableError(e)));
      const transactionIdMaybe = transactionId ? { transactionId: transactionId.uuid } : {};
      log.error(e, 'special-offer-order-failed', {
        ...transactionIdMaybe,
        listingId: orderParams.listing.id.uuid,
        bookingStart: orderParams.bookingDates.bookingStart,
        bookingEnd: orderParams.bookingDates.bookingEnd,
        lineItems: orderParams.bookingData.specialOffer,
      });
      throw e;
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchTimeSlotsRequest);
  // Time slots can be fetched for 90 days at a time,
  // for at most 180 days from now. If max number of bookable
  // day exceeds 90, a second request is made.
  // For LandTrust, We've extended this out to requesting up to 365 days,
  // by creating 5 separate requests of up to 90 days each.
  const maxTimeSlots = 89;
  // booking range: today + bookable days -1
  const bookingRange = config.dayCountAvailableForBooking - 1;
  const timeSlotsRange = Math.min(bookingRange, maxTimeSlots);

  const start = moment
    .utc()
    .startOf('day')
    .toDate();
  const end = moment()
    .utc()
    .startOf('day')
    .add(timeSlotsRange, 'days')
    .toDate();

  const params = { listingId, start, end, per_page: maxTimeSlots };

  return dispatch(timeSlotsRequest(params))
    .then(timeSlots => {
      // As long as bookingRange (configured in config.js) is further out than the next number of timeSlots
      // another request is made, up to 365 days.
      const secondRequest = bookingRange > maxTimeSlots;
      const thirdRequest = bookingRange > maxTimeSlots * 2;
      const fourthRequest = bookingRange > maxTimeSlots * 3;
      const fifthRequest = bookingRange > maxTimeSlots * 4;
      const secondRange = Math.min(maxTimeSlots, bookingRange - maxTimeSlots);
      const thirdRange = Math.min(maxTimeSlots, bookingRange - (maxTimeSlots + secondRange));
      const fourthRange = Math.min(
        maxTimeSlots,
        bookingRange - (maxTimeSlots + secondRange + thirdRange)
      );
      const fifthRange = Math.min(
        maxTimeSlots,
        bookingRange - (maxTimeSlots + secondRange + thirdRange + fourthRange)
      );
      // each of these params are used in their respective API calls to fetch more availability dates.
      const secondParams = {
        listingId,
        start: end,
        end: moment(end)
          .add(secondRange, 'days')
          .toDate(),
        per_page: maxTimeSlots,
      };
      const thirdParams = {
        listingId,
        start: secondParams.end,
        end: moment(secondParams.end)
          .add(thirdRange, 'days')
          .toDate(),
        per_page: maxTimeSlots,
      };
      const fourthParams = {
        listingId,
        start: thirdParams.end,
        end: moment(thirdParams.end)
          .add(fourthRange, 'days')
          .toDate(),
        per_page: maxTimeSlots,
      };
      const fifthParams = {
        listingId,
        start: fourthParams.end,
        end: moment(fourthParams.end)
          .add(fifthRange, 'days')
          .toDate(),
        per_page: maxTimeSlots,
      };
      // depending on what config.dayCountAvailableForBooking
      // up to 5 requests will be made of no more than 90 days each
      switch (true) {
        case fifthRequest:
          dispatch(timeSlotsRequest(secondParams)).then(secondBatch => {
            timeSlots.push(...secondBatch);
          });
          dispatch(timeSlotsRequest(thirdParams)).then(thirdBatch => {
            timeSlots.push(...thirdBatch);
          });
          dispatch(timeSlotsRequest(fourthParams)).then(fourthBatch => {
            timeSlots.push(...fourthBatch);
          });
          dispatch(timeSlotsRequest(fifthParams)).then(fifthBatch => {
            timeSlots.push(...fifthBatch);
          });
          dispatch(fetchTimeSlotsSuccess(timeSlots));
          break;
        case fourthRequest:
          dispatch(timeSlotsRequest(secondParams)).then(secondBatch => {
            timeSlots.push(...secondBatch);
          });
          dispatch(timeSlotsRequest(thirdParams)).then(thirdBatch => {
            timeSlots.push(...thirdBatch);
          });
          dispatch(timeSlotsRequest(fourthParams)).then(fourthBatch => {
            timeSlots.push(...fourthBatch);
          });
          dispatch(fetchTimeSlotsSuccess(timeSlots));
          break;
        case thirdRequest:
          dispatch(timeSlotsRequest(secondParams)).then(secondBatch => {
            timeSlots.push(...secondBatch);
          });
          dispatch(timeSlotsRequest(thirdParams)).then(thirdBatch => {
            timeSlots.push(...thirdBatch);
          });
          dispatch(fetchTimeSlotsSuccess(timeSlots));
          break;
        case secondRequest:
          dispatch(timeSlotsRequest(secondParams)).then(secondBatch => {
            timeSlots.push(...secondBatch);
          });
          dispatch(fetchTimeSlotsSuccess(timeSlots));
          break;
        default:
          dispatch(fetchTimeSlotsSuccess(timeSlots));
      }
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(storableError(e)));
    });
};

export const fetchTransaction = (id, txRole, params) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionRequest(txRole));
  let txResponse = null;
  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'booking',
          'listing',
          'listing.images',
          'reviews',
          'reviews.author',
          'reviews.subject',
          'messages.sender',
        ],
        ...IMAGE_VARIANTS,
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;

      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];
      const transaction = denormalised[1];
      const currentOrExpiredOrAcceptedEnquiry =
        txIsEnquired(transaction) ||
        txIsEnquiryExpired(transaction) ||
        txIsAccepted(transaction) ||
        txIsCustomerCancellableNonRefundable(transaction);
      // Fetch time slots for transactions that are in enquired state
      const canFetchTimeslots =
        config.enableAvailability && transaction && currentOrExpiredOrAcceptedEnquiry;

      if (canFetchTimeslots) {
        dispatch(fetchTimeSlots(listingId));
      }

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...IMAGE_VARIANTS,
        });
      }
      return response;
    })
    .then(response => {
      dispatch(addMarketplaceEntities(txResponse));
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchTransactionSuccess(txResponse));

      if (params?.tab) {
        dispatch(
          fetchOrderOrSaleSuccess({
            ...txResponse,
            type: params.tab,
          })
        );
      }
      dispatch(fetchCurrentUser({ include: ['stripeCustomer.defaultPaymentMethod'] }));
      const transactionRef = { id, type: 'transaction' };
      const entities = getMarketplaceEntities(getState(), [transactionRef]);

      return entities[0];
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

export const fetchTransactionsTogether = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsTogetherRequest());

  const apiQueryParams = {
    only: 'sale',
    lastTransitions: [
      'transition/complete',
      'transition/expire-review-period',
      'transition/expire-customer-review-period',
      'transition/review-1-by-customer',
      'transition/review-2-by-customer',
      'transition/expire-provider-review-period',
      'transition/review-1-by-provider',
      'transition/review-2-by-provider',
    ],
    userId: id,
  };

  sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      const transactions = response.data.data;
      const hasOrdersTogether = response.data.data && response.data.data.length > 0;

      dispatch(fetchTransactionsTogetherSuccess(transactions, hasOrdersTogether));
    })
    .catch(e => dispatch(fetchTransactionsTogetherError(storableError(e))));
};

export const confirmSpecialOfferPayment = params => async (dispatch, getState, sdk) => {
  const { id } = params;
  dispatch(confirmOfferPaymentRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);
    const packageItem = get(currentTransaction, 'attributes.protectedData.packageLineItem', {});

    const listingId = get(currentTransaction, 'relationships.listing.data.id', null);
    const currentListing = getListingById(getState(), listingId.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_SPECIAL_CUSTOMER_PAYMENT,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeCapture({
        id,
      });
    }

    // Update package quantity
    const packages = get(currentListing, 'attributes.publicData.packages', []);

    const updatedPackages = packages.map(p => {
      if (p.id === packageItem.id && p?.quantity) {
        return {
          ...p,
          quantity: {
            ...p.quantity,
            booked: p.quantity.booked + 1,
          },
        };
      }
      return p;
    });

    dispatch(updateListing(listingId, { publicData: { packages: updatedPackages } }));
    dispatch(addMarketplaceEntities(response));
    dispatch(confirmOfferPaymentSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    // Fire GA4 purchase event directly from the Accept-initiating client
    // to prevent duplicate events from shared Redux success action
    trackPurchaseEventDirectly(
      transaction.id.uuid,
      convertMoneyToNumber(transaction.attributes.payinTotal),
      transaction.relationships?.listing?.data?.id?.uuid || null
    );

    return response;
  } catch (e) {
    dispatch(confirmOfferPaymentError(storableError(e)));
    log.error(e, 'confirm-special-offer-failed', {
      txId: id,
      transition: TRANSITION_ACCEPT,
    });
    throw e;
  }
};

export const acceptSpecialOffer = (params, id) => async (dispatch, getState, sdk) => {
  if (acceptOrDeclineInProgress(getState())) {
    return Promise.reject(new Error('Accept or decline already in progress'));
  }
  dispatch(acceptSaleRequest());

  const { currentUser, currentListing, currentProvider } = params;

  const bodyParams = {
    currentUser: {
      id: currentUser.id,
      stripeCustomer: currentUser.stripeCustomer,
    },
    currentListing: {
      id: currentListing.id,
      title: get(currentListing, 'attributes.title'),
    },
    currentProvider: {
      id: currentProvider.id,
    },
  };

  try {
    let paymentIntent;

    const currentTransaction = getTransactionById(getState(), id.uuid);

    if (!isLegacyPaymentFlow(currentTransaction)) {
      const { data } = await stripeCreate({ id, bodyParams });
      const { stripePaymentIntentClientSecret, stripePaymentIntentId } = data;

      paymentIntent = {
        stripePaymentIntentClientSecret,
        stripePaymentIntentId,
      };
    }

    const protectedData = {
      utm: {
        ...analytics.all(),
      },
    };

    if (paymentIntent) {
      protectedData.stripePaymentIntents = {
        default: paymentIntent,
      };
    }

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_CUSTOMER_ACCEPT_OFFER,
        params: {
          protectedData,
        },
      },
      { expand: true }
    );

    dispatch(addMarketplaceEntities(response));
    dispatch(acceptSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );
    return response;
  } catch (e) {
    dispatch(acceptSaleError(storableError(e)));
    log.error(e, 'accept-sale-failed', {
      txId: id,
      transition: TRANSITION_ACCEPT,
    });
    throw e;
  }
};

export const acceptSale = id => async (dispatch, getState, sdk) => {
  if (acceptOrDeclineInProgress(getState())) {
    return Promise.reject(new Error('Accept or decline already in progress'));
  }
  dispatch(acceptSaleRequest());

  const currentTransaction = getTransactionById(getState(), id.uuid);
  const listingId = get(currentTransaction, 'relationships.listing.data.id', null);
  const currentListing = getListingById(getState(), listingId.uuid);
  const packageItem = get(currentTransaction, 'attributes.protectedData.packageLineItem', {});

  try {
    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeCapture({
        id,
      });
    }
  } catch (e) {
    dispatch(acceptSaleError(storableError(e)));
    log.error(e, 'accept-sale-failed-capture', {
      txId: id,
      transition: TRANSITION_ACCEPT,
    });
    throw e;
  }

  try {
    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_ACCEPT,
        params: {
          protectedData: {
            utm: { ...analytics.all() },
          },
        },
      },
      { expand: true }
    );

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    // Update package quantity
    const packages = get(currentListing, 'attributes.publicData.packages', []);

    const updatedPackages = packages.map(p => {
      if (p.id === packageItem.id && p?.quantity) {
        return {
          ...p,
          quantity: {
            ...p.quantity,
            booked: p.quantity.booked + 1,
          },
        };
      }
      return p;
    });

    dispatch(updateListing(listingId, { publicData: { packages: updatedPackages } }));
    dispatch(addMarketplaceEntities(response));
    dispatch(acceptSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());
    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    // Fire GA4 purchase event directly from the Accept-initiating client
    // to prevent duplicate events from shared Redux success action
    trackPurchaseEventDirectly(
      transaction.id.uuid,
      convertMoneyToNumber(transaction.attributes.payinTotal),
      transaction.relationships?.listing?.data?.id?.uuid || null
    );

    await dispatch(fetchTransaction(id, 'customer'));

    return response;
  } catch (e) {
    dispatch(acceptSaleError(storableError(e)));
    log.error(e, 'accept-sale-failed', {
      txId: id,
      transition: TRANSITION_ACCEPT,
    });
    throw e;
  }
};

// Customer can cancel transaction with Full refund up to 48 hours after the booking is accepted
export const cancelSaleCustomerWithRefund = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_CUSTOMER_CANCEL_WITH_REFUND,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeRefund({
        id,
      });

      if (hasPaymentIntent(currentTransaction, PAYMENT_INTENT_TYPES.BOOKING_CHANGES)) {
        if (hasProviderAcceptedChanges(currentTransaction)) {
          await stripeRefund({
            id,
            intentType: PAYMENT_INTENT_TYPES.BOOKING_CHANGES,
          });
        }
      }
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(cancelSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(cancelSaleError(storableError(e)));
    log.error(e, 'cancel-sale-failed', {
      txId: id,
    });
    throw e;
  }
};

// 48 hours after the booking is accepted, the Customer can cancel transaction, with no refund
export const cancelSaleCustomerWithoutRefund = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_CUSTOMER_CANCEL_WITHOUT_REFUND,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripePayout({
        id,
      });
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(cancelSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(cancelSaleError(storableError(e)));
    log.error(e, 'cancel-sale-failed', {
      txId: id,
    });
    throw e;
  }
};

// Customer can cancel transaction even if booked within 48 hours of booking date, with no refund
export const cancelSaleCustomerLate = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_CUSTOMER_LATE_CANCEL,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripePayout({
        id,
      });
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(cancelSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(cancelSaleError(storableError(e)));
    log.error(e, 'cancel-sale-failed', {
      txId: id,
    });
    throw e;
  }
};

// provider can cancel transaction, full refund to customer
export const cancelSaleProviderEarly = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_PROVIDER_EARLY_CANCEL,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeRefund({
        id,
      });

      if (hasPaymentIntent(currentTransaction, PAYMENT_INTENT_TYPES.BOOKING_CHANGES)) {
        if (hasProviderAcceptedChanges(currentTransaction)) {
          await stripeRefund({
            id,
            intentType: PAYMENT_INTENT_TYPES.BOOKING_CHANGES,
          });
        }
      }
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(cancelSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(cancelSaleError(storableError(e)));
    log.error(e, 'cancel-sale-failed', {
      txId: id,
    });
    throw e;
  }
};

// provider can cancel transaction with full refund to customer, even if customer can no longer cancel themselves with a full refund
export const cancelSaleProvider = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_PROVIDER_CANCEL,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeRefund({
        id,
      });

      if (hasPaymentIntent(currentTransaction, PAYMENT_INTENT_TYPES.BOOKING_CHANGES)) {
        if (hasProviderAcceptedChanges(currentTransaction)) {
          await stripeRefund({
            id,
            intentType: PAYMENT_INTENT_TYPES.BOOKING_CHANGES,
          });
        }
      }
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(cancelSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(cancelSaleError(storableError(e)));
    log.error(e, 'cancel-sale-failed', {
      txId: id,
    });
    throw e;
  }
};

// Provider can cancel sale late, between 48 hours until booking date or closer,
// the customer will receive a full refund and the customer will have the option to review the provider
export const cancelSaleProviderLate = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_PROVIDER_LATE_CANCEL,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeRefund({
        id,
      });

      if (hasPaymentIntent(currentTransaction, PAYMENT_INTENT_TYPES.BOOKING_CHANGES)) {
        if (hasProviderAcceptedChanges(currentTransaction)) {
          await stripeRefund({
            id,
            intentType: PAYMENT_INTENT_TYPES.BOOKING_CHANGES,
          });
        }
      }
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(cancelSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(cancelSaleError(storableError(e)));
    log.error(e, 'cancel-sale-failed', {
      txId: id,
    });
    throw e;
  }
};

export const declineSpecialOffer = id => async (dispatch, getState, sdk) => {
  if (acceptOrDeclineInProgress(getState())) {
    return Promise.reject(new Error('Accept or decline already in progress'));
  }
  dispatch(declineSaleRequest());

  return sdk.transactions
    .transition(
      {
        id,
        transition: TRANSITION_CUSTOMER_DECLINE_OFFER,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(declineSaleSuccess(id));
      dispatch(declineOfferSuccess(id));
      dispatch(fetchCurrentUserNotifications());

      const entities = denormalisedResponseEntities(response);
      const transaction = entities[0];

      dispatch(
        updateTransactionTransition(
          transaction.id.uuid,
          transaction.attributes.createdAt.toISOString(),
          transaction.attributes.lastTransition,
          transaction.attributes.lastTransitionedAt.toISOString()
        )
      );
      return response;
    })
    .catch(e => {
      dispatch(declineSaleError(storableError(e)));
      log.error(e, 'reject-sale-failed', {
        txId: id,
        transition: TRANSITION_CUSTOMER_DECLINE_OFFER,
      });
      throw e;
    });
};

export const cancelSpecialOffer = id => async (dispatch, getState, sdk) => {
  if (cancelInProgress(getState())) {
    return Promise.reject(new Error('Cancellation already in progress'));
  }
  dispatch(cancelSaleRequest());

  return sdk.transactions
    .transition(
      {
        id,
        transition: TRANSITION_PROVIDER_CANCEL_OFFER,
        params: { protectedData: { utm: { ...analytics.all() } } },
      },
      { expand: true }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(cancelSaleSuccess(id));
      dispatch(cancelOfferSuccess(id));
      dispatch(fetchCurrentUserNotifications());

      const entities = denormalisedResponseEntities(response);
      const transaction = entities[0];

      dispatch(
        updateTransactionTransition(
          transaction.id.uuid,
          transaction.attributes.createdAt.toISOString(),
          transaction.attributes.lastTransition,
          transaction.attributes.lastTransitionedAt.toISOString()
        )
      );

      return response;
    })
    .catch(e => {
      dispatch(cancelSaleError(storableError(e)));
      log.error(e, 'cancel-sale-failed', {
        txId: id,
      });
      throw e;
    });
};

export const declineSale = id => async (dispatch, getState, sdk) => {
  if (acceptOrDeclineInProgress(getState())) {
    return Promise.reject(new Error('Accept or decline already in progress'));
  }
  dispatch(declineSaleRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);

    const response = await sdk.transactions.transition(
      {
        id,
        transition: TRANSITION_DECLINE,
        params: {
          protectedData: {
            utm: { ...analytics.all() },
          },
        },
      },
      { expand: true }
    );

    if (!isLegacyPaymentFlow(currentTransaction)) {
      await stripeCancel({
        id,
      });
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(declineSaleSuccess(id));
    dispatch(fetchCurrentUserNotifications());

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(declineSaleError(storableError(e)));
    log.error(e, 'reject-sale-failed', {
      txId: id,
      transition: TRANSITION_DECLINE,
    });
    throw e;
  }
};

export const fetchMessages = (txId, limit = 100, nextToken) => async (dispatch, getState) => {
  dispatch(fetchMessagesRequest());

  const query = `
    query GetMessages($input: MessagesInput!) {
      Messages(input: $input) {
        items {
          content
          createdAt
          customerId
          messageSource
          providerId
          senderId
          transactionId
        }
        nextToken
      }
    }
  `;

  const variables = {
    input: {
      transactionId: txId.uuid,
      limit,
      nextToken,
    },
  };

  try {
    const response = await callGraphQLApi(query, variables);
    const apiMessages = response?.data?.Messages?.items || [];

    // Get locally stored messages
    const localMessages = getTransactionMessages(txId.uuid) || [];

    // Merge API messages with local messages, removing duplicates based on createdAt timestamp
    const mergedMessages = [...apiMessages];

    // Add local messages that don't exist in API response and clean up duplicates
    localMessages.forEach(localMsg => {
      const exists = apiMessages.some(apiMsg => apiMsg.createdAt === `${localMsg.createdAt}`);
      if (!exists) {
        mergedMessages.push(localMsg);
      } else {
        // If message exists in API, remove it from local storage
        removeTransactionMessage(txId.uuid, localMsg.createdAt);
      }
    });

    // Sort messages by createdAt timestamp
    mergedMessages.sort((a, b) => {
      const timeA = parseInt(a.createdAt, 10);
      const timeB = parseInt(b.createdAt, 10);
      return timeA - timeB;
    });

    dispatch(fetchMessagesSuccess(txId, mergedMessages));
    return Promise.resolve(mergedMessages);
  } catch (error) {
    dispatch(fetchMessagesError(error));
    return Promise.reject(error);
  }
};

export const fetchMoreMessages = txId => (dispatch, getState) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.Transaction;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages ? oldestMessagePageFetched + 1 : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage));
};

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));

      return res.data.data;
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const updatePartyMemberDetails = (values, transaction) => (dispatch, getState, sdk) => {
  const transactionId = transaction.id;
  const lastTransition = get(transaction, 'attributes.lastTransition', null);
  let nextTransition = null;
  if (lastTransition === TRANSITION_CONFIRM_PAYMENT) {
    nextTransition = TRANSITION_PARTY_MEMBERS_SUBMITTED_1;
  }
  if (lastTransition === TRANSITION_ACCEPT) {
    nextTransition = TRANSITION_PARTY_MEMBERS_SUBMITTED_2;
  }
  if (lastTransition === TRANSITION_REFUND_PERIOD_OVER) {
    nextTransition = TRANSITION_PARTY_MEMBERS_SUBMITTED_3;
  }

  dispatch(updatePartyMemberDetailsRequest());

  return sdk.transactions
    .transition({
      id: transactionId,
      transition: nextTransition,
      params: { protectedData: values },
    })
    .then(() => dispatch(fetchTransaction(transactionId, 'customer')))
    .then(() => dispatch(updatePartyMemberDetailsSuccess(transactionId)))
    .then(window.scrollTo(0, 0))
    .catch(() => updatePartyMemberDetailsError());
};

const getRequestChangesTransition = lastTransition =>
  [TRANSITION_REFUND_PERIOD_OVER, TRANSITION_CHANGES_REQUEST_EXPIRE_AFTER_REFUND].includes(
    lastTransition
  )
    ? TRANSITION_REQUESTED_CHANGES_AFTER_REFUND_PERIOD
    : TRANSITION_REQUESTED_CHANGES;

const getBookingChangesProtectedData = ({
  currentTransaction,
  stripePaymentIntentId,
  customerTotal,
  applicationTotal,
  changedTotals,
  lineItems,
  newValues,
  originalValues,
  partySizeChanged,
  datesChanged,
}) => {
  const stripePaymentIntents = get(
    currentTransaction,
    'attributes.protectedData.stripePaymentIntents',
    {}
  );

  let updatedStripePaymentIntents = {
    ...stripePaymentIntents,
  };

  if (stripePaymentIntentId) {
    updatedStripePaymentIntents = {
      ...updatedStripePaymentIntents,
      [PAYMENT_INTENT_TYPES.BOOKING_CHANGES]: {
        stripePaymentIntentId,
      },
    };
  }

  const updatedLineItems = JSON.stringify(lineItems);
  const originalCustomerTotal = changedTotals.customerTotal?.amount - customerTotal?.amount;
  const originalLandTrustTotal = changedTotals.applicationTotal?.amount - applicationTotal?.amount;
  const originalProviderTotal = originalCustomerTotal - originalLandTrustTotal;

  const updatedAmounts = {
    customerTotal: {
      currency: customerTotal?.currency,
      amount: originalCustomerTotal / 100,
    },
    newCustomerTotal: {
      currency: changedTotals.customerTotal?.currency,
      amount: changedTotals.customerTotal?.amount / 100,
    },
    customerTotalDifference: {
      currency: changedTotals.customerTotal?.currency,
      amount: (changedTotals.customerTotal?.amount - originalCustomerTotal) / 100,
    },
    providerTotal: {
      currency: customerTotal?.currency,
      amount: originalProviderTotal / 100,
    },
    newProviderTotal: {
      currency: changedTotals.customerTotal?.currency,
      amount: changedTotals.providerTotal?.amount / 100,
    },
    providerTotalDifference: {
      currency: changedTotals.customerTotal?.currency,
      amount: (changedTotals.providerTotal?.amount - originalProviderTotal) / 100,
    },
    landTrustTotal: {
      currency: applicationTotal?.currency,
      amount: originalLandTrustTotal / 100,
    },
    newLandTrustTotal: {
      currency: changedTotals.applicationTotal?.currency,
      amount: changedTotals.applicationTotal?.amount / 100,
    },
    landTrustTotalDifference: {
      currency: changedTotals.customerTotal?.currency,
      amount: (changedTotals.applicationTotal?.amount - originalLandTrustTotal) / 100,
    },
  };

  return {
    stripePaymentIntents: updatedStripePaymentIntents,
    bookingChanges: {
      status: 'pending',
      newValues,
      originalValues,
      updatedLineItems,
      updatedAmounts,
      partySizeChanged,
      datesChanged,
    },
  };
};

const finalizeRequestChangesTransition = (dispatch, response, id) => {
  dispatch(addMarketplaceEntities(response));
  dispatch(requestChangesSuccess(id));

  const entities = denormalisedResponseEntities(response);
  const transaction = entities[0];

  dispatch(
    updateTransactionTransition(
      transaction.id.uuid,
      transaction.attributes.createdAt.toISOString(),
      transaction.attributes.lastTransition,
      transaction.attributes.lastTransitionedAt.toISOString()
    )
  );

  return response;
};

export const requestChanges = (params, id) => async (dispatch, getState, sdk) => {
  if (requestChangesInProgress(getState())) {
    return Promise.reject(new Error('Request changes already in progress'));
  }
  dispatch(requestChangesRequest());

  const {
    currentUser,
    currentListing,
    currentProvider,
    lineItems,
    newValues,
    originalValues,
    partySizeChanged,
    datesChanged,
    createPayment,
    clientSideConfirm,
  } = params;

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);
    const { data: paymentIntent } = await stripeRetrieve({
      id,
    });

    const currentPackage = get(currentTransaction, 'attributes.protectedData.packageLineItem', {});
    const packageTitle = get(currentPackage, 'title', '');
    const listingTitle = get(currentListing, 'attributes.title', '');

    const bodyParams = {
      currentUser: {
        id: currentUser.id,
        stripeCustomer: currentUser.stripeCustomer,
      },
      currentListing: {
        id: currentListing.id,
        title: listingTitle,
      },
      currentProvider: {
        id: currentProvider.id,
      },
      currentPackage: {
        packageId: currentPackage.id,
        packageTitle,
      },
      paymentIntent,
      lineItems,
      overrideDescription: `Booking changes for ${listingTitle} - ${packageTitle}`,
      confirmPayment: !clientSideConfirm,
    };

    let data;
    let stripePaymentIntentId;
    let stripePaymentIntentClientSecret;
    let customerTotal;
    let applicationTotal;
    let changedTotals;

    if (createPayment) {
      const response = await stripeCreate({ id, bodyParams });
      data = response.data;
      stripePaymentIntentId = data.stripePaymentIntentId;
      stripePaymentIntentClientSecret = data.stripePaymentIntentClientSecret;
      customerTotal = data.customerTotal;
      applicationTotal = data.applicationTotal;
      changedTotals = data.changedTotals;
    } else {
      const response = await compareLineItemTotals({ id, lineItems });
      data = response.data;
      customerTotal = data.customerTotal;
      applicationTotal = data.applicationTotal;
      changedTotals = data.changedTotals;
    }

    // Client-side confirm path: return the clientSecret so the UI can
    // render Stripe Elements and let the guest enter card details.
    // The transition will be completed by completeRequestChanges after
    // client-side payment confirmation.
    if (clientSideConfirm && createPayment) {
      dispatch(requestChangesSuccess(id));

      return {
        clientSecret: stripePaymentIntentClientSecret,
        stripePaymentIntentId,
        customerTotal,
        applicationTotal,
        changedTotals,
        requiresClientConfirmation: true,
      };
    }

    const updatedProtectedData = getBookingChangesProtectedData({
      currentTransaction,
      stripePaymentIntentId,
      customerTotal,
      applicationTotal,
      changedTotals,
      lineItems,
      newValues,
      originalValues,
      partySizeChanged,
      datesChanged,
    });

    const response = await sdk.transactions.transition(
      {
        id,
        transition: getRequestChangesTransition(
          get(currentTransaction, 'attributes.lastTransition', null)
        ),
        params: {
          protectedData: updatedProtectedData,
        },
      },
      { expand: true }
    );

    return finalizeRequestChangesTransition(dispatch, response, id);
  } catch (e) {
    dispatch(requestChangesError(storableError(e)));
    log.error(e, 'request-changes-customer-failed', {
      txId: id,
      transition: TRANSITION_ACCEPT,
    });
    throw e;
  }
};

/**
 * Creates a PaymentIntent for booking changes without confirming it.
 * Called eagerly by the UI when a price increase is detected and the
 * guest has no saved payment method, so the card form can render inline.
 */
export const createBookingChangePaymentIntent = (params, id) => async (dispatch, getState) => {
  const { currentUser, currentListing, currentProvider, lineItems } = params;

  const currentTransaction = getTransactionById(getState(), id.uuid);
  const { data: paymentIntent } = await stripeRetrieve({ id });

  const currentPackage = get(currentTransaction, 'attributes.protectedData.packageLineItem', {});
  const packageTitle = get(currentPackage, 'title', '');
  const listingTitle = get(currentListing, 'attributes.title', '');

  const bodyParams = {
    currentUser: {
      id: currentUser.id,
      stripeCustomer: currentUser.stripeCustomer,
    },
    currentListing: {
      id: currentListing.id,
      title: listingTitle,
    },
    currentProvider: {
      id: currentProvider.id,
    },
    currentPackage: {
      packageId: currentPackage.id,
      packageTitle,
    },
    paymentIntent,
    lineItems,
    overrideDescription: `Booking changes for ${listingTitle} - ${packageTitle}`,
    confirmPayment: false,
  };

  const response = await stripeCreate({ id, bodyParams });
  const { data } = response;

  return {
    clientSecret: data.stripePaymentIntentClientSecret,
    stripePaymentIntentId: data.stripePaymentIntentId,
    customerTotal: data.customerTotal,
    applicationTotal: data.applicationTotal,
    changedTotals: data.changedTotals,
  };
};

/**
 * Completes the booking change transition after the guest has confirmed
 * payment client-side via Stripe Elements. Called by the UI after
 * stripe.confirmPayment() succeeds.
 */
export const completeRequestChanges = (params, id) => async (dispatch, getState, sdk) => {
  dispatch(requestChangesRequest());

  const {
    stripePaymentIntentId,
    customerTotal,
    applicationTotal,
    changedTotals,
    lineItems,
    newValues,
    originalValues,
    partySizeChanged,
    datesChanged,
  } = params;

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);
    const updatedProtectedData = getBookingChangesProtectedData({
      currentTransaction,
      stripePaymentIntentId,
      customerTotal,
      applicationTotal,
      changedTotals,
      lineItems,
      newValues,
      originalValues,
      partySizeChanged,
      datesChanged,
    });

    const response = await sdk.transactions.transition(
      {
        id,
        transition: getRequestChangesTransition(
          get(currentTransaction, 'attributes.lastTransition', null)
        ),
        params: {
          protectedData: updatedProtectedData,
        },
      },
      { expand: true }
    );

    return finalizeRequestChangesTransition(dispatch, response, id);
  } catch (e) {
    dispatch(requestChangesError(storableError(e)));
    log.error(e, 'request-changes-complete-failed', {
      txId: id,
    });
    throw e;
  }
};

export const acceptChanges = id => async (dispatch, getState, sdk) => {
  if (acceptChangesInProgress(getState())) {
    return Promise.reject(new Error('Accept changes already in progress'));
  }
  dispatch(acceptChangesRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);
    const lastTransition = get(currentTransaction, 'attributes.lastTransition', null);

    const listing = getListingById(
      getState(),
      currentTransaction.relationships.listing.data.id.uuid
    );

    const timezone = getListingTimezone(listing);
    const bookingChanges = get(currentTransaction, 'attributes.protectedData.bookingChanges', {});
    const emailLineItems = get(currentTransaction, 'attributes.protectedData.emailLineItems', []);
    const packageLineItem = get(currentTransaction, 'attributes.protectedData.packageLineItem', {});
    const datesChanged = get(bookingChanges, 'datesChanged', false);
    const partySizeChanged = get(bookingChanges, 'partySizeChanged', false);
    const newValues = get(bookingChanges, 'newValues', {});
    const updatedLineItems = get(bookingChanges, 'updatedLineItems', {});
    const params = {};
    const updatedProtectedData = {};

    if (datesChanged) {
      // We wanna get the date at the listing location.
      // This will then be used for the display dates which are hooked
      // with our process.end transitions

      const bookingStart = JSON.parse(newValues.dates.startDate);
      const bookingEnd = JSON.parse(newValues.dates.endDate);
      let bookingLodgingDateRaw = null;

      try {
        bookingLodgingDateRaw = JSON.parse(newValues?.dates?.startLodgingDate);
      } catch (e) {
        bookingLodgingDateRaw = null;
      }

      const bookingStartDate = moment(bookingStart).format('YYYY-MM-DD');
      const bookingEndDate = moment(bookingEnd).format('YYYY-MM-DD');
      const bookingLodgingDate = bookingLodgingDateRaw
        ? moment(bookingLodgingDateRaw).format('YYYY-MM-DD')
        : null;

      const bookingStartDateInLocale = moment.tz(`${bookingStartDate} 00:00:00`, timezone);
      const bookingEndDateInLocale = moment.tz(`${bookingEndDate} 23:59:59`, timezone);
      const bookingLodgingDayInLocale = bookingLodgingDate
        ? moment.tz(`${bookingLodgingDate} 00:00:00`, timezone)
        : null;

      const bookingStartDateInLocaleInUTC = moment(bookingStartDateInLocale).utc();
      const bookingEndDateInLocaleInUTC = moment(bookingEndDateInLocale).utc();

      const bookingDisplayStart = bookingStartDateInLocaleInUTC.toDate();
      const bookingDisplayEnd = bookingEndDateInLocaleInUTC.toDate();

      updatedProtectedData.bookingDates = {
        start: bookingStartDateInLocale.format(),
        end: bookingEndDateInLocale.format(),
        startLodgingDate: bookingLodgingDayInLocale ? bookingLodgingDayInLocale.format() : null,
        timezone,
        days: daysBetween(bookingStartDateInLocale.format(), bookingEndDateInLocale.format()) + 1,
      };

      const apiBookingEnd = moment
        .utc(bookingEnd)
        .set({ hour: 0, minute: 0, seconds: 0 })
        .add(1, 'd')
        .toDate();
      const apiBookingStart = moment
        .utc(bookingStart)
        .set({ hour: 0, minute: 0 })
        .toDate();

      params.protectedData = updatedProtectedData;
      params.bookingStart = apiBookingStart;
      params.bookingEnd = apiBookingEnd;
      params.bookingDisplayStart = bookingDisplayStart;
      params.bookingDisplayEnd = bookingDisplayEnd;
    }

    const newPartySize = get(newValues, 'partySize', 0);

    if (partySizeChanged) {
      if (newPartySize.flexibleGuestSize) {
        updatedProtectedData.flexibleGuestSize = newPartySize.flexibleGuestSize;
        updatedProtectedData.packageLineItem = {
          ...packageLineItem,
          guestSize: newPartySize.partySize,
        };
      } else {
        updatedProtectedData.packageLineItem = {
          ...packageLineItem,
          guestSize: newPartySize,
        };
      }
    }

    if (newPartySize.flexibleGuestSize) {
      const updatedLineItemsParsed = JSON.parse(updatedLineItems);
      const updatedEmailLineItems = emailLineItems.map(item => {
        const findLineItem = updatedLineItemsParsed.find(lineItem => lineItem.code === item.code);
        let newDays = item.days;

        if (datesChanged) {
          const parsedStartDate = JSON.parse(newValues.dates.startDate);
          const parsedEndDate = JSON.parse(newValues.dates.endDate);
          const parsedLodgingDate = newValues.dates.startLodgingDate
            ? JSON.parse(newValues.dates.startLodgingDate)
            : null;

          newDays = daysAdded(parsedStartDate, parsedEndDate);

          if (parsedStartDate === parsedLodgingDate) {
            newDays -= 1;
          }
        }

        if (findLineItem) {
          switch (item.code) {
            case LINE_ITEM_ADULT_HUNTER: {
              const newGuestSize = newPartySize.flexibleGuestSize.adultHunter;
              const newLineTotalAmount = findLineItem.lineTotal.amount / 100;
              const newQuantity = newGuestSize * newDays;

              return {
                ...item,
                days: newDays,
                guestSize: newGuestSize,
                quantity: newQuantity,
                lineTotal: {
                  ...item.lineTotal,
                  amount: newLineTotalAmount,
                },
              };
            }

            case LINE_ITEM_ADULT_NON_HUNTER: {
              const newGuestSize = newPartySize.flexibleGuestSize.adultNonHunter;
              const newLineTotalAmount = findLineItem.lineTotal.amount / 100;
              const newQuantity = newGuestSize * newDays;

              return {
                ...item,
                days: newDays,
                guestSize: newGuestSize,
                quantity: newQuantity,
                lineTotal: {
                  ...item.lineTotal,
                  amount: newLineTotalAmount,
                },
              };
            }

            case LINE_ITEM_YOUTH_HUNTER: {
              const newGuestSize = newPartySize.flexibleGuestSize.youthHunter;
              const newLineTotalAmount = findLineItem.lineTotal.amount / 100;
              const newQuantity = newGuestSize * newDays;

              return {
                ...item,
                days: newDays,
                guestSize: newGuestSize,
                quantity: newQuantity,
                lineTotal: {
                  ...item.lineTotal,
                  amount: newLineTotalAmount,
                },
              };
            }

            case LINE_ITEM_YOUTH_NON_HUNTER: {
              const newGuestSize = newPartySize.flexibleGuestSize.youthNonHunter;
              const newLineTotalAmount = findLineItem.lineTotal.amount / 100;
              const newQuantity = newGuestSize * newDays;

              return {
                ...item,
                days: newDays,
                guestSize: newGuestSize,
                quantity: newQuantity,
                lineTotal: {
                  ...item.lineTotal,
                  amount: newLineTotalAmount,
                },
              };
            }
            default:
              return item;
          }
        }

        return item;
      });

      updatedProtectedData.emailLineItems = updatedEmailLineItems;
    }

    updatedProtectedData.bookingChanges = {
      ...bookingChanges,
      status: 'accepted',
    };

    params.protectedData = updatedProtectedData;

    let nextTransition = TRANSITION_ACCEPTED_CHANGES;

    if (lastTransition === TRANSITION_REQUESTED_CHANGES_AFTER_REFUND_PERIOD) {
      nextTransition = TRANSITION_ACCEPTED_CHANGES_AFTER_REFUND_PERIOD;
    }

    const response = await sdk.transactions.transition(
      {
        id,
        transition: nextTransition,
        params,
      },
      { expand: true }
    );

    dispatch(fetchTransaction(id, 'provider'));

    if (hasPaymentIntent(currentTransaction, PAYMENT_INTENT_TYPES.BOOKING_CHANGES)) {
      await stripeCapture({
        id,
        intentType: PAYMENT_INTENT_TYPES.BOOKING_CHANGES,
      });
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(acceptChangesSuccess(id));

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(acceptChangesError(storableError(e)));
    log.error(e, 'accept-changes-failed', {
      txId: id,
      transition: TRANSITION_ACCEPTED_CHANGES,
    });
    throw e;
  }
};

export const declineChanges = id => async (dispatch, getState, sdk) => {
  if (declineChangesInProgress(getState())) {
    return Promise.reject(new Error('Decline changes already in progress'));
  }
  dispatch(declineChangesRequest());

  try {
    const currentTransaction = getTransactionById(getState(), id.uuid);
    const lastTransition = get(currentTransaction, 'attributes.lastTransition', null);

    const bookingChanges = get(currentTransaction, 'attributes.protectedData.bookingChanges', {});

    const updatedProtectedData = {
      bookingChanges: {
        ...bookingChanges,
        status: 'declined',
      },
    };

    let nextTransition = TRANSITION_DECLINED_CHANGES;

    if (lastTransition === TRANSITION_REQUESTED_CHANGES_AFTER_REFUND_PERIOD) {
      nextTransition = TRANSITION_DECLINED_CHANGES_AFTER_REFUND_PERIOD;
    }

    const response = await sdk.transactions.transition(
      {
        id,
        transition: nextTransition,
        params: {
          protectedData: updatedProtectedData,
        },
      },
      { expand: true }
    );

    if (hasPaymentIntent(currentTransaction, PAYMENT_INTENT_TYPES.BOOKING_CHANGES)) {
      await stripeCancel({
        id,
        intentType: PAYMENT_INTENT_TYPES.BOOKING_CHANGES,
      });
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(declineChangesSuccess(id));

    const entities = denormalisedResponseEntities(response);
    const transaction = entities[0];

    dispatch(
      updateTransactionTransition(
        transaction.id.uuid,
        transaction.attributes.createdAt.toISOString(),
        transaction.attributes.lastTransition,
        transaction.attributes.lastTransitionedAt.toISOString()
      )
    );

    return response;
  } catch (e) {
    dispatch(declineChangesError(storableError(e)));
    log.error(e, 'decline-changes-failed', {
      txId: id,
      transition: TRANSITION_DECLINED_CHANGES,
    });
    throw e;
  }
};

export const markMessagesRead = (
  transactionId,
  createdAt,
  userType,
  msgCreatedAt
) => async dispatch => {
  dispatch(markMessagesReadRequest());

  const mutation = `
    mutation MarkMessagesRead($input: MarkMessagesReadInput!) {
      MarkMessagesRead(input: $input) 
    }
  `;

  const variables = {
    input: {
      transactionId,
      createdAt,
      userType,
      timestamp: msgCreatedAt,
    },
  };

  try {
    const response = await callGraphQLApi(mutation, variables);
    dispatch(markMessagesReadSuccess(response.data.MarkMessagesRead));

    queryClient.invalidateQueries({ queryKey: [TRANSACTIONS_QUERY_KEY] });

    return response.data.MarkMessagesRead;
  } catch (error) {
    dispatch(markMessagesReadError(error));
    throw error;
  }
};

export const createTransaction = formattedTransaction => async () => {
  const mutation = `
    mutation CreateTransaction($input: CreateTransactionInput!) {
      CreateTransaction(input: $input) 
    }
  `;

  const variables = {
    input: {
      data: JSON.stringify(formattedTransaction),
    },
  };

  return callGraphQLApi(mutation, variables);
};

export const updateTransactionMetadata = (id, metadata) => async (dispatch, getState, sdk) => {
  dispatch(updateTransactionMetadataRequest());

  try {
    const response = await updateTransactionMetadataApi({
      id,
      metadata,
    });

    dispatch(updateTransactionMetadataSuccess(response));
    return response;
  } catch (e) {
    dispatch(updateTransactionMetadataError(storableError(e)));
    throw e;
  }
};
